import React, { Component, createRef } from 'react';

import Select from '../../../../../../Shared/React/js/components/Select';
import ComparisonHelper from '../../../utils/ComparisonHelper';
import ModalDataSlider from './ModalDataSlider';

export default class TabletTab extends Component {
    constructor(props) {
        super(props);

        // TODO: Remove this, use polyfill service
        /* eslint-disable-next-line no-extend-native */
        Array.prototype.groupBy = function (prop) {
            return this.reduce(function (groups, item) {
                const val = item[prop];
                groups[val] = groups[val] || [];
                groups[val].push(item);
                return groups;
            }, {});
        };

        this.state = {
            initialCriteria: JSON.stringify([props.criteria.tabletShortUrl, props.criteria.tabletPriceTypes]),
            tabletShortUrl: props.criteria.tabletShortUrl,
            selectedPriceTypes: props.criteria.tabletPriceTypes
        };

        this.comparisonHelper = new ComparisonHelper();
        this.wrapper = createRef();
        this.onPriceTypeChanged = this.onPriceTypeChanged.bind(this);
    }

    componentDidMount() {
        const dom = wo$(this.wrapper.current);
        this.bindTablet(dom);

        dom.find('[data-toggle="popover"]').popover();
    }

    static getDerivedStateFromProps(props, state) {
        const initialCriteria = JSON.stringify([props.criteria.tabletShortUrl, props.criteria.tabletPriceTypes]);

        return initialCriteria !== state.initialCriteria
            ? {
                  initialCriteria: initialCriteria,
                  tabletShortUrl: props.criteria.tabletShortUrl,
                  selectedPriceTypes: props.criteria.tabletPriceTypes
              }
            : null;
    }

    componentDidUpdate() {
        const dom = wo$(this.wrapper.current);
        this.bindTablet(dom);
    }

    AreEqual(array1, array2, totalCount) {
        array1 = array1 || [];
        array2 = array2 || [];

        return (
            array1 === array2 ||
            JSON.stringify(array1.sort()) === JSON.stringify(array2.sort()) ||
            (array1.length === 0 && array2.length === totalCount) ||
            (array2.length === 0 && array1.length === totalCount)
        );
    }

    bindTablet(dom, tabletShortUrl, simOnly, simType) {
        // TODO: Consider rewriting using the React approach

        const valueOnly = typeof tabletShortUrl !== 'undefined';

        let simOnlyValue = '';
        if (valueOnly && simOnly) {
            simOnlyValue = 'byo-0';
            if (simType) {
                simOnlyValue = `byo-${simType}`;
            }
        } else if (this.props.criteria.includeSimOnly) {
            simOnlyValue = 'byo-0';
            if (this.props.criteria.simType) {
                simOnlyValue = `byo-${this.props.criteria.simType}`;
            }
        }

        const select = dom.find('#choose-tablet');
        if (!valueOnly) {
            WhistleOut.applySelectPicker(select);
        }
        if (valueOnly) {
            if (simOnly) {
                select.selectpicker('val', simOnlyValue);
            } else {
                select.selectpicker('val', tabletShortUrl);
            }
        } else {
            if (this.props.criteria.tabletShortUrl) {
                const selectedValue = this.props.criteria.tabletShortUrl;
                select.selectpicker('val', selectedValue);
            } else if (this.props.criteria.includeSimOnly) {
                select.selectpicker('val', simOnlyValue);
            }
        }

        if (!valueOnly) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const that = this;
            select.on('change', function () {
                const selectedValue = wo$(this).selectpicker('val');

                if (selectedValue.indexOf('byo-') >= 0) {
                    let simType = selectedValue.replace('byo-', '');
                    if (!simType || simType.length < 1 || simType === '0') {
                        simType = null;
                    }
                    that.setState({ tabletShortUrl: null });
                    that.props.modalActions.changeTablet(null, true, simType);
                } else {
                    that.setState({ tabletShortUrl: selectedValue });
                    that.props.modalActions.changeTablet(selectedValue);
                }
            });
        }
    }

    getTabletName(shortUrl) {
        if (!shortUrl || shortUrl.length <= 0) {
            return 'No Tablet Selected';
        }

        const currentTablet = this.props.tabletSelector.tablets.find(t => t.shortUrl === shortUrl);
        return currentTablet.name;
    }

    getTabletImages(shortUrl) {
        if (!shortUrl || shortUrl.length <= 0) {
            if (this.props.tabletSelector.includeSimOnly) {
                return this.props.tabletSelector.byoTabletImageUrl;
            }

            return this.props.tabletSelector.addTabletImageUrl;
        }

        const currentTablet = this.props.tabletSelector.tablets.find(t => t.shortUrl === shortUrl);
        return currentTablet.imageUrl;
    }

    onPriceTypeChanged(values) {
        this.setState({ selectedPriceTypes: values }, () =>
            this.props.modalActions.changeTabletPriceTypes(values, this.props.allTabletPriceTypes)
        );
    }

    disablePriceTypes() {
        return !this.state.tabletShortUrl || this.state.tabletShortUrl.length <= 0;
    }

    render() {
        const tabletsGrouped = this.props.tabletSelector.tablets.groupBy('manufacturer');
        const tabletsByManufacturer = [];

        if (this.props.tabletSelector.simTypes) {
            const simTypes = Object.keys(this.props.tabletSelector.simTypes).map(key => {
                return { shortUrl: `byo-${key}`, name: this.props.tabletSelector.simTypes[key] };
            });

            tabletsByManufacturer.push({ manufacturer: '', tablets: simTypes });
        }

        for (var manufacturerName in tabletsGrouped) {
            tabletsByManufacturer.push({ manufacturer: manufacturerName, tablets: tabletsGrouped[manufacturerName] });
        }

        const disablePriceTypes = this.disablePriceTypes();
        return (
            <div className="row" ref={this.wrapper}>
                <div className="[ col-sm-10 ] [ col-md-7 ] [ text-center ]">
                    <div className="row  pad-y-4">
                        <div className="[ col-xs-8  col-xs-offset-8 ] [ col-sm-24  col-sm-offset-0 ]">
                            {' '}
                            <img
                                src={this.getTabletImages(this.props.criteria.tabletShortUrl).large}
                                alt={this.getTabletName(this.props.criteria.tabletShortUrl)}
                                className="img-responsive center-block"
                            />{' '}
                        </div>
                    </div>
                    <div className="selectpicker-wide">
                        <select
                            id="choose-tablet"
                            tabIndex={-1}
                            className="selectpicker bs-select-hidden"
                            data-live-search="true"
                        >
                            <option>{this.props.resources.noTabletSelected}</option>
                            {tabletsByManufacturer.map(manufacturerGroup => {
                                return (
                                    <optgroup
                                        label={manufacturerGroup.manufacturer}
                                        key={`manufacturer-${manufacturerGroup.manufacturer}`}
                                    >
                                        {manufacturerGroup.tablets.map(tablet => {
                                            return (
                                                <option key={tablet.id || tablet.shortUrl} value={tablet.shortUrl}>
                                                    {tablet.name}
                                                </option>
                                            );
                                        })}
                                    </optgroup>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div className="[ col-sm-12 col-sm-offset-2 ] [ col-md-7 col-md-offset-1 ]">
                    <div className="row">
                        <div
                            className="col-xs-24 bor-b-1 pad-y-2 mar-b-4 hover-bg"
                            data-container="body"
                            data-toggle="popover"
                            data-placement="top"
                            data-content={this.props.dataTooltip}
                            data-original-title=""
                            title=""
                        >
                            <h5 className="font-5">
                                {' '}
                                {this.props.resources.monthlyUsage}{' '}
                                <span className="text-muted font-6">
                                    <i className="fa fa-info-circle" />
                                </span>
                            </h5>
                        </div>
                    </div>
                    <ModalDataSlider
                        {...this.props.dataSlider}
                        current={this.props.criteria.minimumData}
                        actions={this.props.modalActions}
                    />
                </div>
                <div className="[ col-sm-24 ] [ col-md-8 col-md-offset-1 ] [ settings-wrap ]">
                    <div className="row">
                        <div
                            className="col-xs-24 bor-b-1 pad-y-2 hover-bg"
                            data-container="body"
                            data-toggle="popover"
                            data-placement="top"
                            data-content={this.props.priceTypesTooltip}
                            data-original-title=""
                            title=""
                        >
                            <h5 className="font-5"> {this.props.resources.tabletPriceOptions}</h5>
                        </div>
                    </div>
                    <div className="row bor-b-1 pad-y-3">
                        <div className="col-xs-24 pad-t-1">
                            <div className="selectpicker-wide">
                                <Select
                                    key="choose-tablet-price-types"
                                    disabled={disablePriceTypes}
                                    multiple
                                    optionGroups={[
                                        {
                                            values: this.props.tabletPriceTypes.map(p => {
                                                return {
                                                    title: p.value,
                                                    key: p.key,
                                                    value: p.value
                                                };
                                            })
                                        }
                                    ]}
                                    width="auto"
                                    onChange={this.onPriceTypeChanged}
                                    selectedValues={disablePriceTypes ? [] : this.state.selectedPriceTypes}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
